import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

export interface ConfirmationDialogInput {
  key: string;
  label?: string;
  type?: 'text' | 'number' | 'email' | 'tel' | 'textarea';
  placeholder?: string;
  required?: boolean;
  defaultValue?: any;
}

export interface ConfirmationDialogData {
  title: string;
  message: string;
  showActions?: boolean;
  isError?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  inputs?: ConfirmationDialogInput[];
}

export interface ConfirmationDialogResult {
  confirmed: boolean;
  values?: Record<string, any>;
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  inputValues: Record<string, any> = {};
  inputTouched: Record<string, boolean> = {};

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    (this.data.inputs || []).forEach((input) => {
      this.inputValues[input.key] = input.defaultValue ?? '';
    });
  }

  get hasInputs(): boolean {
    return (this.data.inputs || []).length > 0;
  }

  isInputInvalid(input: ConfirmationDialogInput): boolean {
    return !!input.required && this.inputTouched[input.key] && !this.inputValues[input.key];
  }

  onConfirm(): void {
    if (this.hasInputs) {
      (this.data.inputs || []).forEach((input) => {
        this.inputTouched[input.key] = true;
      });

      const hasInvalidInput = (this.data.inputs || []).some((input) =>
        this.isInputInvalid(input),
      );
      if (hasInvalidInput) {
        return;
      }

      this.dialogRef.close({ confirmed: true, values: this.inputValues });
      return;
    }

    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
